import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton, EllipsisDropdownItem, PlainTooltip } from "@similarweb/ui-components";

import type { ICurrency } from "app/common/constants/currencies";
import { i18nFilter } from "app/filters/i18nFilter";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

interface ISelectedAppFilterProps {
    currencies: ICurrency[];
    selectedCurrency: ICurrency;
    onCurrencyChange: any;
    withoutMargin?: boolean;
}
const DropdownWrapper = styled(FlexRow)<{ withoutMargin?: boolean }>`
    margin-right: ${(withoutMargin) => (withoutMargin ? "0" : "12px")};

    .DropdownButton--disabled .CategoryDropdownItem--parent {
        color: ${colorsPalettes.midnight[100]};
    }
    @media print {
        display: none;
    }
`;

export const CurrencySelector: FC<ISelectedAppFilterProps> = ({
    currencies,
    onCurrencyChange,
    selectedCurrency = currencies[0],
    withoutMargin = false,
}) => {
    const handleItemClick = (e) => {
        if (e.id !== "CURRENCY") {
            const cur = currencies.filter((c) => e.id === c.name)[0];
            onCurrencyChange(cur);
        }
    };

    const dropDownItems = currencies?.map((currency, index) => (
        <EllipsisDropdownItem
            id={currency.name}
            key={currency.name}
        >
            {currency.shortIcon} {currency.name}
        </EllipsisDropdownItem>
    ));
    const tooltipContent = (
        <FlexColumn>
            <div>
                <div>
                    <b>{i18nFilter()("websiteanalysis.trafficsources.paidsearch.graph.currency.titleTooltip")}</b>
                </div>
                {i18nFilter()("websiteanalysis.trafficsources.paidsearch.graph.currency.tooltip")}
            </div>
        </FlexColumn>
    );
    return (
        <>
            {selectedCurrency ? (
                <PlainTooltip
                    text="websiteanalysis.trafficsources.paidsearch.graph.currency.tooltip"
                    cssClass="categorypicker-tooltip"
                    tooltipContent={tooltipContent}
                >
                    <DropdownWrapper withoutMargin={withoutMargin}>
                        <Dropdown
                            selectedIds={{ [selectedCurrency.name]: true }}
                            onClick={handleItemClick}
                            dropdownPopupPlacement="ontop-right"
                        >
                            {[
                                <DropdownButton
                                    width={95}
                                    key="dropdownButton0"
                                >
                                    {selectedCurrency.shortIcon} {selectedCurrency.name}
                                </DropdownButton>,

                                <EllipsisDropdownItem
                                    id={"CURRENCY"}
                                    key={"CURRENCY"}
                                    className={"currencyTitle"}
                                >
                                    {i18nFilter()("websiteanalysis.trafficsources.paidsearch.graph.currency.title")}
                                </EllipsisDropdownItem>,
                                ...dropDownItems,
                            ]}
                        </Dropdown>
                    </DropdownWrapper>
                </PlainTooltip>
            ) : null}
        </>
    );
};
